export default __webpack_public_path__ + "static/media/transpaleta2.30ccd856.jpg";